var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-1 overflow-auto"},[(_vm.isEnabledWidgetV2)?_c('PrechatFormV2',{attrs:{"options":_vm.preChatFormOptions},on:{"submit":_vm.onSubmit}}):_c('PreChatForm',{attrs:{"options":_vm.preChatFormOptions},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }